import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import BannerMarquee from "./components/BannerMarquee";
import FloatingContact from "./components/FloatingContact";
import Footer from "./components/Footer";
import UserMenu from "./components/UserMenu";
import Home from "./pages/Home";
import Introduction from "./pages/Introduction";
import AdminLogin from "./pages/AdminLogin";
import Contact from "./pages/Contact";
import Courses from "./pages/Courses";
import CourseDetail from "./pages/CourseDetail";
import CourseForm from "./pages/CourseForm";
import GuideForm from "./pages/GuideForm";
import Guides from "./pages/Guides";
import Dashboard from "./pages/Dashboard";
import Profile from "./pages/Profile";
import Posts from "./pages/Posts";
import PostDetail from "./pages/PostDetail";
import PostForm from "./pages/PostForm";
import ProtectedRoute from "./routes/ProtectedRoute";
import ScrollToTop from "./components/ScrollToTop";
import PromoPopup from "./components/PromoPopup";

function App() {
  return (
    <Router>
      <PromoPopup />
      <ScrollToTop />
      <div className="flex flex-col min-h-screen">
        <Navbar />

        <main className="flex-grow mt-20">
          <BannerMarquee />
          <div className="fixed bottom-30 right-4 z-50">
            <UserMenu />
          </div>
          <FloatingContact />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/gioi-thieu" element={<Introduction/>} />
            <Route path="/khoa-hoc" element={<Courses/>} />
            <Route path="/khoa-hoc/:slug" element={<CourseDetail/>} />
            <Route path="/admin/courses/:id" element={<CourseForm/>} />
            <Route path="/admin/courses/create" element={<CourseForm/>} />
            <Route path="/cam-nang" element={<Guides/>} />
            <Route path="/admin/guides/:id" element={<GuideForm/>} />
            <Route path="/admin/guides/create" element={<GuideForm/>} />
            <Route path="/lien-he" element={<Contact />} />
            <Route path="/tin-tuc" element={<Posts />} />
            <Route path="/tin-tuc/:slug" element={<PostDetail />} />
            <Route path="/admin/posts/:id" element={<PostForm />} />
            <Route path="/admin/posts/create" element={<PostForm />} />
            <Route path="/login" element={<AdminLogin />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;
